var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dm_detail_card"},[_c('div',[_c('FormPreview',{attrs:{"exam":_vm.question}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }